
import * as React from 'react';
import { CommandBarButton, IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { css } from '@uifabric/utilities/lib/css';

export interface ICommandBarItemRenderProps extends IButtonProps {
  item: IContextualMenuItem;
  buttonRef?: React.Ref<CommandBarButton>;
}

export function commandBarItemDefaultRender(props: ICommandBarItemRenderProps): JSX.Element {
  const {
    item,
    buttonRef,
    ...buttonProps
  } = props;

  const itemOnClick = item.onClick;

  const onClick = itemOnClick ? (ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | undefined) => {
    itemOnClick(ev, item);
  } : undefined;

  // TODO Move this chunk to a 'defaultRender' behavior in Fabric.
  const itemText = item.text || item.name;

  const commandButtonProps: ICommandBarItemProps = {
    allowDisabledFocus: true,
    ...item,
    styles: { root: { height: '100%' }, ...item.buttonStyles },
    className: css('ms-CommandBarItem-link', item.className),
    text: !item.iconOnly ? itemText : undefined,
    menuProps: item.subMenuProps,
    onClick: onClick
  };

  return (
    <CommandBarButton
      ref={ buttonRef }
      { ...commandButtonProps as IButtonProps }
      { ...buttonProps }
    />
  );
}
